module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/67f1f57354ec093fbd27d823301db905.png";